import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { useTranslation } from 'react-i18next';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { tagListQueryOptions } from './use-tags';

type UpdateTagRequest = { TagId: number; TagName: string };

export default function useUpdateTag() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, UpdateTagRequest>({
    mutationFn: (params) => fetcher('/UpdateTag', params, { validResponseCodes: [0] }),
    onSuccess: (_, params) => {
      addToast({
        type: 'success',
        message: t('common.rename-success'),
      });

      queryClient.setQueryData(tagListQueryOptions.queryKey, (state) =>
        produce(state, (draft) => {
          if (draft) {
            const index = draft.findIndex((tag) => tag.Id === params.TagId);
            if (index !== -1 && draft[index]) {
              draft[index].TagName = params.TagName;
            }
          }

          return draft;
        }),
      );
    },
  });
}
